import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "experience-video" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  muted: "",
  playsinline: "",
  loop: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "/public/home_page/img/vr-section.MP4",
    type: "video/mp4"
  }),
  /*#__PURE__*/_createTextVNode("Your browser does not support the video tag. ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}